import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Logo from '../Logo';

const TransitionsModal = ({title, open, children}) => {

  return (

      <Modal
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >

        <Fade in={open}>
   
            <Box  sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '90vw',
              maxWidth: 1000,
              bgcolor: 'background.main',
              boxShadow: 24,
              borderRadius: 1,
              margin: 'auto',
              border: 1,
              borderColor: 'primary.text',
              maxHeight: '90%',
              overflowY: 'auto',
            }}>

              <Box sx={{
                borderTopLeftRadius: 1,
                borderTopRightRadius: 1,
                padding: 0.5,
              }}>

                <Typography 
                  component='h1' 
                  variant='h6' 
                  sx={{ 
                    display: 'flex', 
                    padding: 1, 
                    color: 'primary.text',
                }}>

                  <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <Logo width={36} height={36}/>
                    <Box sx={{mr: 1, ml: 1}}>
                      {title}
                    </Box>
                  </Box>

                </Typography>

              </Box>

              <Box 
              sx={{
                padding: 1,
              }}>
                {children}
              </Box>
        
            </Box>

        </Fade>

      </Modal>

  );

};

export default TransitionsModal;
